import { render, staticRenderFns } from "./BaseHero.vue?vue&type=template&id=3439fe1d&"
import script from "./BaseHero.vue?vue&type=script&lang=js&"
export * from "./BaseHero.vue?vue&type=script&lang=js&"
import style0 from "./BaseHero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports